import { useQuery, useMutation, useQueryClient } from "@tanstack/react-query";
import { supabase } from "@/integrations/supabase/client";

export function useTimesheetApprovalSetting() {
  const qc = useQueryClient();

  const { data: approvalRequired = true, isLoading } = useQuery({
    queryKey: ["timesheet_approval_setting"],
    queryFn: async () => {
      const { data: companyId } = await supabase.rpc("my_company_id");
      if (!companyId) return true;
      const { data, error } = await supabase
        .from("company_settings")
        .select("timesheet_approval_required")
        .eq("company_id", companyId)
        .maybeSingle();
      if (error) throw error;
      return (data as any)?.timesheet_approval_required ?? true;
    },
  });

  const update = useMutation({
    mutationFn: async (value: boolean) => {
      const { data: companyId } = await supabase.rpc("my_company_id");
      if (!companyId) throw new Error("Company not found");
      const { error } = await supabase
        .from("company_settings")
        .update({ timesheet_approval_required: value } as any)
        .eq("company_id", companyId);
      if (error) throw error;
    },
    onSuccess: () => {
      qc.invalidateQueries({ queryKey: ["timesheet_approval_setting"] });
    },
  });

  return { approvalRequired, isLoading, update };
}
